import { AdmissionsCriterion, CriteriaCategory, groupCriteria } from 'components/shared/ai/AdmissionsCriteria';
import { AICriteriaCategorySnapshot, AIJobCriterion } from 'models/AIJob';

// Group an admission job's evaluated criteria by category for the criteria drawer, ordered by the
// configured category order and then criterion order. Delegates the grouping + color validation to
// the shared `groupCriteria` (also used by the referral clinical assessment).
export function groupCriteriaByCategory(criteria: AIJobCriterion[]): CriteriaCategory[] {
  const ordered = [...criteria].sort(
    (a, b) => categoryOf(a).order - categoryOf(b).order || a.aiCriteria.order - b.aiCriteria.order
  );

  return groupCriteria(
    ordered.map((c) => {
      const category = categoryOf(c);
      return {
        categoryId: category.id,
        categoryName: category.name,
        categoryColor: category.color,
        criterion: criterionFrom(c),
      };
    })
  );
}

// OLIO-2697 rename transition: prefer the new `aiCriteriaCategory` snapshot, fall back to the
// legacy `aiCriteriaSetCategory`. Test the new key for content rather than truthiness — rows
// written during the api rollout window carry the jsonb column default, {}, which is truthy, so
// `??` and `||` would both skip the fallback. OLIO-2698 drops the legacy key and this guard.
function categoryOf(c: AIJobCriterion): AICriteriaCategorySnapshot {
  return c.aiCriteriaCategory?.name ? c.aiCriteriaCategory : c.aiCriteriaSetCategory;
}

function criterionFrom(c: AIJobCriterion): AdmissionsCriterion {
  return {
    label: c.aiCriteria.criterion,
    description: c.aiCriteria.description || undefined,
    sourceCount: c.sources.length,
    sources: c.sources.map((s) => ({ attachmentId: s.attachmentId, displayId: s.displayId })),
  };
}
